import {
    // axios,
    axiosWithoutHeaders,
} from "../cores/axiosWrapper";
import contentTypeConverter from "../cores/contentTypeConverter";
import { withRetryNetworkRequest } from "@utils/withRetryNetworkRequest";

const sendFileDataForPreSigned = (params) => {
    const {
        file,
        cancelToken,
        hashedStr,
        onUploadProgress = () => {},
        onComplete = () => {},
        onCancel = () => {},
        onError = (err) => {},
    } = params;
    // hash 값을 저장하는 곳에서 사용하기 위함
    file.hash = hashedStr;
    const contentType = contentTypeConverter.getContentTypeFromUrl(file.uploadUrl);
    withRetryNetworkRequest(() =>
        axiosWithoutHeaders.put(file.uploadUrl, file, {
            headers: {
                "Content-Type": contentType,
            },
            customErrorMessage: true,
            onUploadProgress,
            cancelToken,
        }),
    )
        .then(({ data }) => {
            onComplete(data);
        })
        .catch((thrown) => {
            if (axiosWithoutHeaders.isCancel(thrown)) {
                onCancel();
            } else {
                onError(thrown);
            }
        });
};

export const sendFileData = ({
    file,
    stageId,
    projectId,
    cancelToken,
    hashedStr,
    onUploadProgress = () => {},
    onComplete = () => {},
    onCancel = () => {},
    onError = () => {},
}) => {
    let params = {
        file,
        stageId,
        projectId,
        cancelToken,
        hashedStr,
        onUploadProgress,
        onComplete,
        onCancel,
        onError,
    };

    if (!file.uploadUrl) {
        throw new Error("upload url is not exist.");
    }

    sendFileDataForPreSigned(params);
};

export default sendFileData;
